import * as Sentry from "@sentry/react";
import React from "react";
import { ErrorOutline } from "@material-ui/icons";
import { Box, Paper, Typography } from "@material-ui/core";

export interface Props {
  children: React.ReactNode;
}

export function ErrorBoundary(props: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={(errorData) => {
        return (
          <Paper style={styles.paper}>
            <Box display="flex">
              <ErrorOutline style={styles.icon} fontSize={"small"} color={"error"} />
              <Typography variant="body1">{errorData.error.toString()}</Typography>
            </Box>
          </Paper>
        );
      }}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
}

export function withErrorBoundary(component: React.ReactNode) {
  return <ErrorBoundary>{component}</ErrorBoundary>;
}

const styles = {
  paper: { backgroundColor: "#ffd2c1", padding: "15px" },
  icon: { marginRight: "10px" }
};
